module.exports = __webpack_public_path__ + "static/media/business2.3fa4bab7.png";